// src/pages/solicitor/SolicitorLogin.js
import React from 'react';
import LoginPage from '../../components/LoginPage';

const SolicitorLogin = () => {
  return (
    <LoginPage userStr="募集人" userType="solicitor" pageTitle="募集人ログイン" />
  );
};

export default SolicitorLogin;